import React, { Component } from 'react';
import Alert from 'sweetalert-react';
import { ButtonToolbar, Button } from 'react-bootstrap';
import NewUser from './NewUser'
import UpdateUser from './UpdateUser'
import * as Http from '../../http'
import * as Business from '../../utils/business'
import Loading from '../../components/Loading'

export default class ListUser extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      data: [],
      showDeleteAlert: false
    }
    this.usernameWillDelete = null
  }

  componentDidMount() {
    this.getNewListUser()
  }

  getNewListUser = () => {
    Http.getListUser()
      .then(res => {
        this.setState({
          loading: false,
          data: res.Data || []
        })
      })
  }

  onCreateNewUser = () => {
    this.getNewListUser()
  }

  onUpdateUser = () => {
    this.getNewListUser()
  }

  deleteUser = () => {
    Http.deleteUser(this.usernameWillDelete)
      .then(res => {
        if (res.Success) {
          this.getNewListUser()
        }
      })
    this.usernameWillDelete = null
  }

  onDelete = username => {
    this.usernameWillDelete = username
    this.setState({
      showDeleteAlert: true
    })
  }

  renderRow = (item) => (
    <tr key={item.UserId}>
      {
        Business.isHasRole([Business.ROLE_DEFINE_MAP.UPDATE_USER])
          ?
          (
            <td>
              <a rel="tooltip"
                className="btn btn-info btn-simple btn-xs"
                data-original-title="View Profile"
                onClick={() => {
                  this.updateUserRef.show(item)
                }}>
                {item.Username}
              </a>
            </td>
          )
          :
          (
            <td> {item.Username} </td>
          )
      }
      {/* <td>{Business.getAccountTypeName(item.AccountType)}</td> */}
      <td>{Business.getRoleName(item.RoleGroupId)}</td>
      <td>{item.Fullname}</td>
      <td>{item.Phone}</td>
      <td>{item.Address}</td>
      <td className="text-right">
        {
          Business.isHasRole([Business.ROLE_DEFINE_MAP.DELETE_USER])
            ? (
              <a rel="tooltip"
                className="btn btn-info btn-simple btn-xs"
                data-original-title="View Profile"
                onClick={() => this.onDelete(item.Username)}>
                <i style={{ fontSize: 23, color: "red" }} className="pe-7s-delete-user"></i>
              </a>
            )
            : (<div></div>)
        }
      </td>
    </tr>
  )

  render() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    return (
      <div className="card">
        <NewUser ref={ref => this.newUserRef = ref} onCreateNewUser={this.onCreateNewUser} />
        <UpdateUser ref={ref => this.updateUserRef = ref} onUpdateUser={this.onUpdateUser} />
        <div className="header">
          <div style={{ width: '100%', display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <h4 className="title">Users</h4>
            {
              Business.isHasRole([Business.ROLE_DEFINE_MAP.CREATE_USER])
              &&
              (
                <ButtonToolbar>
                  <Button bsSize="small" style={{
                    borderRadius: '5px',
                    fontWeight: 600,
                    marginLeft: "auto"
                  }} onClick={() => this.newUserRef.show()}>New User</Button>
                </ButtonToolbar>
              )
            }
          </div>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Username</th>
                {/* <th>Account Type</th> */}
                <th>Role</th>
                <th>Full Name</th>
                <th>Phone</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map(this.renderRow)}
            </tbody>
          </table>
        </div>
        <Alert
          title="Are you sure?"
          show={this.state.showDeleteAlert}
          text="You will not be able to recover this user!"
          showCancelButton
          onConfirm={() => {
            this.setState({ showDeleteAlert: false })
            this.deleteUser()
          }}
          onCancel={() => {
            this.setState({ showDeleteAlert: false })
            this.usernameWillDelete = null
          }} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/User/ListUser.js